export default "__VITE_ASSET__CchFFwZc__"